// import api, { getToken } from 'common/request';
// import { getToken } from 'shj-utils'
import { getToken } from '@/common/utils.ts'
import request, { baseURL, METHODS } from '@/api'

// let Service2 = process.env.apiBaseUrl

const typeDic = {
  docx: 'application/msword',
  doc: 'application/msword',
  bin: 'application/octet-stream',
  exe: 'application/octet-stream',
  so: 'application/octet-stream',
  dll: 'application/octet-stream',
  pdf: 'application/pdf',
  ai: 'application/postscript',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  dir: 'application/x-director',
  js: 'application/x-javascript',
  swf: 'application/x-shockwave-flash',
  xhtml: 'application/xhtml+xml',
  xht: 'application/xhtml+xml',
  zip: 'application/zip',
  mid: 'audio/midi',
  midi: 'audio/midi',
  mp3: 'audio/mpeg',
  rm: 'audio/x-pn-realaudio',
  rpm: 'audio/x-pn-realaudio-plugin',
  wav: 'audio/x-wav',
  bmp: 'image/bmp',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  css: 'text/css',
  html: 'text/html',
  htm: 'text/html',
  txt: 'text/plain',
  xsl: 'text/xml',
  xml: 'text/xml',
  mpeg: 'video/mpeg',
  mpg: 'video/mpeg',
  avi: 'video/x-msvideo',
  movie: 'video/x-sgi-movie',
}
// https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding

export const fileDownload = (
  url,
  {
    decode = 'gbk',
    method = METHODS.GET,
    useIconv = true,
    name = '下载文件',
    onDownloadProgress = undefined,
    baseURL,
    headers,
    data,
    ...rest
  }: any = {}
) => {
  const reqOptions: any = {
    method,
    responseType: 'blob',
    data: data ? data : rest,
    raw: true,
    onDownloadProgress: onDownloadProgress,
  }

  if (baseURL) {
    reqOptions.baseURL = baseURL
  }
  if (headers) {
    reqOptions.headers = headers
  } else {
    reqOptions.headers = { Authorization: getToken() }
  }

  return request(url, reqOptions).then((res: any) => {
    const { data } = res
    let fileName =
      res.headers['content-disposition'] &&
      res.headers['content-disposition'].replace(/attachment;\s*filename=/, '')

    const contentType = res.headers['content-type'] || ''

    // let decodeFileName
    // if (useIconv) {
    //   decodeFileName = decode ? iconv.decode(fileName, decode) : fileName
    // } else {
    //   decodeFileName = decodeURIComponent(fileName)
    // }
    if (!fileName) {
      fileName = name
    }

    let extension = fileName
    if (!extension.includes('.')) {
      extension = url
    }

    const decodeFileName = decodeURIComponent(fileName || '下载文件')

    const fileType = extension?.split('.')?.pop() || ''

    const blob = new Blob([data], { type: typeDic[fileType] || contentType.split(';')[0] })
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = downloadUrl

    link.setAttribute('download', decodeFileName || 'file')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return res
  })
}

export const fileLink = url => {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = baseURL + `${url}?Authorization=${getToken()}`
  // link.target = '_blank';
  // link.setAttribute('download', decodeFileName);
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
